import React from 'react';
import ReactDOM from 'react-dom';
import firebase from 'firebase'
import Main from './Main';
const config = {
    apiKey: "AIzaSyCi-g4qfCAMTpUVUmZjcT6-xcSAZqh8vsU",
    authDomain: "link-showcase-9f46f.firebaseapp.com",
    projectId: "link-showcase-9f46f",
    storageBucket: "link-showcase-9f46f.appspot.com",
    messagingSenderId: "332192062173",
    appId: "1:332192062173:web:558f4331258c7e9935d934",
    measurementId: "G-TZPD2BZY77"
};
firebase.initializeApp(config)
ReactDOM.render(<Main />, document.getElementById('root'));
